/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React, { useEffect, useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import * as Llamadas from '../Llamadas';
import countryData from './CountryCodes.json';

function Informacion(props) {

  const traducciones = props.traducciones;

  const [formData, setFormData] = useState({
    contacto: null
  });

  const [contacto, setContacto] = useState({
    nombre: formData.contacto?.nombre || '',
    apellidos: formData.contacto?.apellidos || '',
    email: formData.contacto?.email || '',
    telefono: formData.contacto?.telefono || '',
    prefijo: formData.contacto?.prefijo || '+34',
    numero: formData.contacto?.numero || '',
    aeropuerto: formData.contacto?.aeropuerto || '',
    aeropuertoObj: formData.aeropuertoObj || '',
    aeropuertoEmail: formData.contacto?.aeropuerto.emailResponsable || '',
    mensaje: formData.contacto?.mensaje || '',
    politicaPrivacidad: formData.contacto?.politicaPrivacidad || false,
    pais: formData.contacto?.pais || ''
  });

  const [urlPrivacidad, setUrlPrivacidad] = useState("");

  var [listaAeropuertos, setListAeropuerto] = useState(props.listaAeropuertosAPI);

  const [countryDataOrdenado, setCountryDataOrdenado] = useState(countryData.sort((a, b) => parseInt(a.dial_code.replace('+', '')) > parseInt(b.dial_code.replace('+', '')) ? 1 : -1));

  const [selectedCountry, setSelectedCountry] = useState({
    name: "Spain",
    dial_code: "+34",
    code: "ES"
  });
  const [activado, setActivado] = useState(false);

  const [errors, setErrors] = useState({
    nombre: false,
    apellidos: false,
    email: false,
    politicaPrivacidad: false,
    incompleteForm: false,
    telefono: false,
    mensaje: false,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const cargarUrl = async () => {
      var url = await Llamadas.getUrlPrivacidad();
      setUrlPrivacidad(url);
    };
    cargarUrl();
  }, []);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setContacto(prevContacto => ({
      ...prevContacto,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors[name] || errors.incompleteForm) {
      setErrors({ ...errors, [name]: false, incompleteForm: false });
    }
  };


  const handleAeropuertoChange = (event) => {
    const selectedAeropuerto = event.target.value;
    const aeropuertoData = props.listaAeropuertosAPI.find(
      (item) => item.nombre === selectedAeropuerto
    );

    Llamadas.logger(aeropuertoData);

    setContacto((prevContacto) => ({
      ...prevContacto,
      aeropuerto: selectedAeropuerto,
      aeropuertoObj: aeropuertoData,
      aeropuertoEmail: aeropuertoData.responsableAeropuerto
    }));
  };



  const handlePhoneChange = (value) => {
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length <= 9) {
      setContacto(prevContacto => ({
        ...prevContacto,
        telefono: numericValue,
        numero: prevContacto.prefijo +" "+ numericValue
      }));
    }
    setErrors(prevErrors => ({
      ...prevErrors,
      telefono: numericValue.length < 9
    }));
  };

  function handleCountrySelect(event) {
    const code = event.code;
    const country = countryDataOrdenado.find(c => c.code === code);
    if (country) {
      setContacto(prev => ({ ...prev, prefijo: country.dial_code, numero: country.dial_code +" "+ prev.telefono }));
      setSelectedCountry({
        name: country.name,
        code: country.code.toLowerCase(),
        dial_code: country.dial_code
      });
      setErrors(prevErrors => ({
        ...prevErrors,
        telefono: false
      }));
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        telefono: Llamadas.traducir(traducciones.errortelefono_i18n)
      }));
    }
    setActivado(false);
  }

  function validateEmail() {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contacto.email);
  }

  function validateNombre() {
    return /^[a-zA-Z\sáéíóúÁÉÍÓÚñÑ-]+$/.test(contacto.nombre.trim());
  }

  function validateApellidos() {
    return /^[a-zA-Z\sáéíóúÁÉÍÓÚñÑ-]+$/.test(contacto.apellidos.trim());
  }

  function areRequiredFieldsFilled() {
    return contacto.nombre.trim() && contacto.apellidos.trim() && contacto.email.trim() && contacto.telefono.trim() && contacto.mensaje.trim() && contacto.politicaPrivacidad;
  }

  function handleEnviar() {
    const isEmailValid = validateEmail();
    const isNombreValid = validateNombre();
    const isApellidosValid = validateApellidos();
    const hasAcceptedPrivacy = contacto.politicaPrivacidad;
    const isFormComplete = areRequiredFieldsFilled();

    setErrors({
      nombre: !isNombreValid,
      apellidos: !isApellidosValid,
      email: !isEmailValid,
      politicaPrivacidad: !hasAcceptedPrivacy,
      incompleteForm: !isFormComplete,
      telefono: errors.telefono
    });

    setFormSubmitted(true);

    if (isNombreValid && isApellidosValid && isEmailValid && hasAcceptedPrivacy && isFormComplete && !errors.telefono) {
      setFormData(prevFormData => ({
        ...prevFormData,
        contacto: contacto
      }));
      let subject = Llamadas.traducir(traducciones.emailsubjectcontacto_i18n);
      Llamadas.mandarEmail(contacto,subject);

      document.getElementById("formContacto").style.display = "none";
      document.getElementById("confirmacionContacto").style.display = "block";
    }
  }

  function desplegarMenu() {
    setActivado(!activado);
  }

  return (
    <main id="main" className="mainVehselecc">
      <div className="box-BBR bg-white">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>{Llamadas.traducir(traducciones.titulo_i18n)}</h1>
            </div>
          </div>
          <form className="form-green" onSubmit={(e) => e.preventDefault()} id="formContacto">
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="idNomapell">{Llamadas.traducir(traducciones.nombreapellidos_i18n)} <span className="oblig"> *</span></label>
                  < input type="text" maxLength={50} className="form-control" id="idNomapell" pattern="[a-zA-Z]" name="nombre" onChange={handleChange} />
                  {
                    errors.nombre && <p className="error-message"> {Llamadas.traducir(traducciones.errornombre_i18n)} </p>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="idApellidos">{Llamadas.traducir(traducciones.apellidos_i18n)} <span className="oblig"> *</span></label>
                  < input type="text" maxLength={50} className="form-control" id="idApellidos" pattern="[a-zA-Z]" name="apellidos" onChange={handleChange} />
                  {
                    errors.apellidos && <p className="error-message"> {Llamadas.traducir(traducciones.errorapellidos_i18n)} </p>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label htmlFor="idEmail">{Llamadas.traducir(traducciones.email_i18n)}<span className="oblig"> *</span></label>
                  < input type="email" maxLength={50} className="form-control" id="idEmail" name="email" onChange={handleChange} />
                  {
                    errors.email && <p className="error-message">{Llamadas.traducir(traducciones.errorcorreo_i18n)}</p>}
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label htmlFor="idPrephone">{Llamadas.traducir(traducciones.telefono_i18n)} <span className="oblig"> *</span></label>
                  <div className="box-phone">
                    <div type="text" className="form-control prephone" aria-label="prephone" aria-describedby="idPrephone" id="idPrephone" onClick={desplegarMenu}>
                      <img src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/${selectedCountry.code.toLowerCase()}.svg`} className="icoFlag" alt="Icono bandera país" />
                      <span className="textFlag"> {selectedCountry.dial_code}</span>
                      <img src="/o/spain-transfers-theme/assets/sm/icons/arrows/arrow_down_secondary.svg" className="icoADSLP" style={activado ? { transform: 'rotate(180deg)' } : { transform: 'rotate(0deg)' }} alt="Icono flecha desplegar lista prefijos" />
                    </div>
                    <input type="tel" className="form-control telphone" aria-label="phone" aria-describedby="idPhone" id="idPhone" value={contacto.telefono} onChange={e => handlePhoneChange(e.target.value)} required />
                  </div>
                  {errors.telefono && <p className="error-message">{Llamadas.traducir(traducciones.errortelefonoinvalido_i18n)}</p>}
                </div>
                <div className="box-listphone" id="dropdownMenuButton" style={activado ? { display: 'flex' } : { display: 'none' }}>
                  <ul className="ul-listphone" aria-haspopup="true" aria-expanded="false" style={activado ? { display: 'flex', transition: 'all 0.2s ease-in' } : { display: 'none', transition: 'all 0.2s ease-in' }}>
                    {countryDataOrdenado.map(country => (
                      <li className="listphone-item" key={country.code} onClick={() => handleCountrySelect(country)}>
                        <img src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/${country.code.toLowerCase()}.svg`} className="icoFlag" alt="Icono bandera país" />
                        <span className="textFlag"> ({country.dial_code})</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label htmlFor="aeropuerto">{Llamadas.traducir(traducciones.aeropuerto_i18n)} {Llamadas.traducir(traducciones.opcional_i18n)}</label>
                  <select id="aeropuerto" name="aeropuerto" className="form-control" onChange={handleAeropuertoChange}>
                    <option value=""></option>
                    {props.listaAeropuertosAPI.map((item) => <option value={item.nombre}>{item.nombre}</option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="idMensaje">{Llamadas.traducir(traducciones.mensaje_i18n)}<span className="oblig"> *</span></label>
                  < textarea type="text" maxLength={278} className="form-control" id="idMensaje" name="mensaje" rows="5" onChange={handleChange} required ></textarea>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="checkbox">
                  <label className="label-checkbox">
                    <input className="input-checkbox" name="politicaPrivacidad" type="checkbox" checked={contacto.politicaPrivacidad} onChange={handleChange} />
                    <span className="fci-r">
                      <i className="fci-r-icon"></i>
                    </span>
                    {Llamadas.traducir(traducciones.politicaprivacidad_i18n)}
                    < a href={urlPrivacidad} className="linkform mx-1" > {
                      Llamadas.traducir(traducciones.politicaprivacidadenlace_i18n)} </a>
                    < span className="oblig" > *</span>
                  </label>
                </div>
              </div>
            </div>

            {formSubmitted && (!areRequiredFieldsFilled() || errors.telefono) && (
              <div className="row">
                <div className="col-12">
                  <div className="box-reserva bg-error">
                    <img src="/o/spain-transfers-theme/assets/sm/icons/general/aviso_rojo.svg" className="ico-alert" alt="Icono de alerta" />
                    <div className="text-reserva">
                      <p>{Llamadas.traducir(traducciones.errorcampos_i18n)}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12">
                <div className="divBtns justify-content-end">
                  <button className="btn btn-primary" type="button" onClick={handleEnviar}>{Llamadas.traducir(traducciones.formularioenviar_i18n)}</button>
                </div>
              </div>
            </div>
          </form>
          <div className="row" id="confirmacionContacto" style={{ display: "none" }}>
            <div className="col-12">
              <div className="box-reserva bg-yellow">
                <img src="/o/spain-transfers-theme/assets/sm/icons/general/check_ok.svg" className="ico-alert" alt="Icono de ok" />
                <div className="text-reserva">
                  <p>{Llamadas.traducir(traducciones.confirmacion_i18n)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Informacion;
